import { LIST_TOKENS } from "@src/constants/tokens"
import { config } from "../../config"

export const WNEAR_ASSET_ID = "nep141:wrap.near"
export const NEAR_TOKEN_ICON = LIST_TOKENS.find(
  (token) => token.symbol === "NEAR"
)?.icon
export const WNEAR_TOKEN_ACCOUNT_ID = "wrap.near"
export const NEAR_DECIMALS = 24
export const NEAR_STAKING_APR_BPS = 456

export function getLstContractId(): string | null {
  return config.env.contractID === "intents.near" ? "lst-pool.near" : null
}

export function getLstAssetId(): string | null {
  const id = getLstContractId()
  return id == null ? null : `nep141:${id}`
}
